// @ts-nocheck
export const parseUrl = (param) => {
  let searchurl = location.href
  let queryStr = searchurl.split('?')[1]
  let queryParams = queryStr.split('#')[0]
  queryParams = queryParams.split('&')
  const obj = {}
  queryParams.forEach(el => {
    el = el.split('=')
    const [prop, value] = el
    obj[prop] = value
  })
  return obj[param]
}



// WEBPACK FOOTER //
// ./src/lib/util.js